import axios from 'axios';

class ArticlesAPI {
  constructor() {
    this.baseUrl = '';
  }

  searchArticles(portalSlug, locale, query) {
    const baseUrl = `${this.baseUrl}/${encodeURIComponent(locale)}/${encodeURIComponent(portalSlug)}/articles.json?${new URLSearchParams({ query })}`;
    return axios.get(baseUrl);
  }
}

export default new ArticlesAPI();
